import { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import { workflowAPI } from '../../lib/api';

export const useWorkflowData = () => {
  const [summary, setSummary] = useState(null);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    try {
      const [s, i] = await Promise.all([workflowAPI.summary(), workflowAPI.items()]);
      setSummary(s.data);
      setItems(i.data || []);
    } catch {
      toast.error('Could not load your queue');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
    const t = setInterval(reload, 30000);
    return () => clearInterval(t);
  }, [reload]);

  return { summary, items, loading, reload };
};
